import React from "react";

export const DeleteModal = ({ originalName, onClick, id }) => {
  return (
    <div
      className="modal fade"
      id={"deleteConfirmation" + (id || "")}
      data-backdrop="static"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="staticBackdrop"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content ant-modal ant-modal-confirm ant-modal-confirm-confirm">
          <div className="ant-modal-content">
            <div className="ant-modal-body">
              <div className="ant-modal-confirm-body-wrapper">
                <div className="align-items-center ant-modal-confirm-body d-flex">
                  <div className="alert-icon pr-5">
                    <i className="flaticon-warning icon-3x text-warning"></i>
                  </div>
                  <span className="ant-modal-confirm-title">
                    Are you sure you want to delete this {originalName}?
                  </span>
                </div>

                <div className="ant-modal-confirm-btns">
                  <button
                    type="button"
                    className="ant-btn"
                    data-dismiss="modal"
                  >
                    <span>No</span>
                  </button>
                  <button
                    type="button"
                    onClick={onClick}
                    className="ant-btn ml-3 border-primary"
                    data-dismiss="modal"
                  >
                    <span>Yes</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
